export default {
    // Blues
    "blue": "#2970FF",
    "blue-dark": "#1A46A9",
    "blue-darkest": "#091440",
    "blue-zodiac": "#18234D",
    // Greys
    "grey-light": "#ABAEBE",
    "grey-steel": "#777E96",
    "grey": "#787F98",
    "grey-smokey": "#707070",
    "grey-regent": "#9196AA",
    "grey-rhino-light": "#3F486B",
    // Whites
    "white": "#FFF",
    "white-lilac": "#F7F7F9",
    "white-lavender": "#DFE0E6",
    "white-ghost": "#CACDD6",
    "white-pink": "#EBECF0",
    "red": "#FF2929",
    // Font
    "font-color": "var(--blue-darkest)",
    "font-size-sm": "10px",
    "font-size-md": "13px",
    "font-size-lg": "15px",
    "font-size-xl": "21px",
    // Layout
    "bg-color": "var(--white-lilac)",
    // Header
    "header-bg-color": "var(--white)",
    "header-bg-gradient": "transparent linear-gradient(240deg, #F7F7F98C 0%, #F7F7F98C 15%, #F7F7F9B9 60%, #F7F7F9E3 100%) 0% 0% no-repeat padding-box",
    "header-lang-toggle-color": "var(--grey-light)",
    // Menu
    "menu-active-color": "var(--blue-darkest)",
    // Main Card
    "main-card-bg-color": "var(--white)",
    "main-card-heading-color": "var(--grey-light)",
    "main-card-heading-line-color": "var(--white-lavender)",
    // Footer
    "footer-bg-color": "var(--white)",
    "sm-color": "var(--blue-darkest)",
    // File Inout
    "file-input-border-color": "var(--white-ghost)",
    "file-input-hover-bg-color": "var(--white-lilac)",
    // Latest Hash
    "latest-hash-section-bg-color": "var(--bg-color)",
    "latest-hash-hover-color": "var(--blue-darkest)",
    // Button
    "button-primary-bg-color": "var(--blue)",
    "button-primary-bg-hover-color": "var(--blue-dark)",
    "button-primary-color": "var(--white)",
    "button-disabled-bg-color": "var(--grey-light)",
    "button-disabled-color": "var(--white-ghost)",
    "button-secondary-bg-color": "var(--grey-light)",
    "button-secondary-bg-hover-color": "var(--grey)",
    "button-secondary-color": "var(--white)",
    "button-tertiary-color": "#5F6683",
    "button-tertiary-border-color": "#E4E6EA",
    "button-tertiary-border-hover-color": "#5F6683",
    // Input
    "input-bg-color": "var(--white-lavender)",
    "input-placeholder-color": "var(--grey)",
    "input-hover-border-color": "var(--white-ghost)",
    // Search
    "search-icon-hover-color": "var(--blue-darkest)",
    "search-input-placeholder-color": "var(--blue-darkest)",
    // Hash view
    "status-color": "var(--blue-darkest)",
    "go-back-color": "var(--white)",
    // Tooltip
    "tooltip-bg-color": "var(--grey-rhino-light)",
    "tooltip-hover-color": "var(--grey-regent)",
    // Icons
    "button-icon-hover-bg-color": "var(--white-pink)",
    "button-icon-hover-color": "var(--blue-darkest)",
    "copy-to-clipboard-color": "var(--grey)",
    "checkbox-color": "var(--white-ghost)",
    "checkbox-check-color": "var(--blue-darkest)",
    // Progress bar
    "progress-bar-border-color": "var(--blue-darkest)",
    "progress-bar-bg-color": "var(--grey-light)",
    "progress-bar-bg-color-step": "var(--grey-steel)",
    "progress-bar-bg-color-done": "var(--blue)",
    // Spinner
    "spinner-border": "rgba(9, 20, 64, 0.3)",
    "spinner-border-top": "var(--blue-darkest)",
    // Toast
    "toast-bg-color": "var(--white)"
};